import React from 'react';
import { ApButtonTab } from '@alixpartners/ui-components';
import {
	Breadcrumbs,
	ContentDiv,
	FlexWrapper,
	NavDiv,
} from '../WorkingCapital.styles';
import { useState } from 'react';
import BenchmarkVendorAnalysis from './BenchmarkVendorAnalysis';
import BenchmarkCategoryAnalysis from './BenchmarkCategoryAnalysis';

function WCBenchmark({ setCurrentContent }) {
	const INITIAL_SUBNAV_CONFIG = [
		{
			id: 0,
			name: 'vendorBenchmark',
			label: 'Vendor Benchmark',
			isActive: true,
			component: BenchmarkVendorAnalysis,
		},
		{
			id: 1,
			name: 'categoryBenchmark',
			label: 'Category Benchmark',
			isActive: false,
			component: BenchmarkCategoryAnalysis,
		},
	];
	const [subNav, setSubNav] = useState(INITIAL_SUBNAV_CONFIG);
	const subNavHandler = value => {
		setSubNav(prevState =>
			prevState.map(el => {
				if (el.id === value) {
					return { ...el, isActive: true };
				} else {
					return { ...el, isActive: false };
				}
			})
		);
	};

	return (
		<div>
			<FlexWrapper>
				<NavDiv>
					{subNav.map(({ id, name, label, isActive }) => (
						<ApButtonTab
							key={id}
							name={name}
							isSelected={isActive}
							onClick={() => {
								subNavHandler(id);
							}}
							small
						>
							{label}
						</ApButtonTab>
					))}
				</NavDiv>
			</FlexWrapper>
			<ContentDiv style={{ height: 'calc(100vh - 186px)', overflow: 'auto' }}>
				{subNav.map(({ id, isActive, component: Component }) => {
					return (
						isActive && (
							<>
								<Breadcrumbs>
									<span onClick={() => setCurrentContent(0)}>
										Category Widgets
									</span>&nbsp;/&nbsp;<span>
										{id === 0 ? 'Vendor Benchmark' : 'Category Benchmark'}
									</span>
								</Breadcrumbs>
								<Component key={id} setCurrentContent={setCurrentContent} />
							</>
						)
					);
				})}
			</ContentDiv>
		</div>
	);
}

export default WCBenchmark;
